export const isDefined = (value: unknown): value is NonNullable<unknown> =>
  value !== undefined && value !== null;

export const isPositiveNumber = (value: number): boolean => value >= 0;

export const removeSpaces = (value: string) => value.replace(/ /g, '');

export const generateRandomKey = () => Math.random().toString(36).slice(2);

export function getNestedValueByPath<T>(
  obj: T,
  path: string | undefined,
): unknown {
  if (!path) {
    return undefined;
  }

  if (!path.includes('.')) {
    return (obj as Record<string, unknown>)[path];
  }

  return path.split('.').reduce<unknown>((acc, key) => {
    if (typeof acc === 'object' && acc !== null) {
      return (acc as Record<string, unknown>)[key];
    }

    return undefined;
  }, obj);
}

export const truncateDecimals = (
  value?: number | null,
  decimals = 2,
): number | null => {
  if (!isDefined(value)) {
    return null;
  }

  const multiplier = Math.pow(10, decimals);

  return Math.trunc(value * multiplier) / multiplier;
};

/**
 * Extracts filename from Content-Disposition header
 */
export const extractFilenameFromHeader = (
  contentDisposition: string,
): string => {
  const parts = contentDisposition.split(';');
  const filenamePart = parts.find((part) =>
    part.trim().startsWith('filename='),
  );

  if (!filenamePart) {
    return 'download';
  }

  let filename = filenamePart.split('=')[1].replace(/"/g, '');

  filename = decodeURI(filename);

  return filename;
};

/**
 * Triggers browser download for a blob with specified filename
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
};
